export const USER_LOGIN = 'USER_LOGIN'
export const PHONE_LOGIN = 'PHONE_LOGIN'
export const WECHAT_LOGIN = 'WECHAT_LOGIN'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_EVALUATION = 'USER_EVALUATION'
export const GET_SERVER_CONFIG = 'GET_SERVER_CONFIG'
export const USER_EXAM_LIST_UPDATE = 'USER_EXAM_LIST_UPDATE'
